import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
import { request as defaultRequest } from "@octokit/request";
import { oauthRequest } from "./utils";

function createDeviceCode(_x) {
  return _createDeviceCode.apply(this, arguments);
}

function _createDeviceCode() {
  _createDeviceCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(options) {
    var request, parameters;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            request = options.request ||
            /* istanbul ignore next: we always pass a custom request in tests */
            defaultRequest;
            parameters = {
              client_id: options.clientId
            };

            if ("scopes" in options && Array.isArray(options.scopes)) {
              parameters.scope = options.scopes.join(" ");
            }

            return _context.abrupt("return", oauthRequest(request, "POST /login/device/code", parameters));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _createDeviceCode.apply(this, arguments);
}

export { createDeviceCode };